import { render, staticRenderFns } from "./CreateUserForm.vue?vue&type=template&id=818ed93a&scoped=true"
import script from "./CreateUserForm.vue?vue&type=script&lang=js"
export * from "./CreateUserForm.vue?vue&type=script&lang=js"
import style0 from "./CreateUserForm.vue?vue&type=style&index=0&id=818ed93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818ed93a",
  null
  
)

export default component.exports